module.exports = __webpack_public_path__ + "static/media/portfolio_single.25ca655a.png";